export default function ScrollTicker() {
  const items = [
    { text: "Personalizamos seus Brindes!", tag: "TOP" },
    { text: "Valores Especiais pra Grandes Quantidades!", tag: "% OFF" },
    { text: "Personalizamos suas Embalagens!", tag: "NOVO" },
    { text: "Suporte pelo WhatsApp!", tag: "24H" },
  ];

  const repeated = [...items, ...items, ...items, ...items, ...items, ...items];

  return (
    <div className="overflow-hidden" style={{ background: "linear-gradient(90deg, #1e3a5f 0%, #2563eb 50%, #1e3a5f 100%)" }}>
      <div className="animate-marquee flex w-max items-center py-2.5">
        {repeated.map((item, i) => (
          <span key={i} className="flex items-center gap-3 whitespace-nowrap px-5 text-sm font-semibold text-white">
            <span className="flex items-center gap-2">
              <span>{item.text}</span>
              <span className="flex items-center rounded-full bg-white/20 px-2.5 py-0.5 text-[10px] font-bold tracking-wide backdrop-blur-sm">
                {item.tag}
              </span>
            </span>
            <span className="mx-2 flex h-1.5 w-1.5 shrink-0 rounded-full bg-white/40" />
            {i % 4 === 2 && (
              <span className="flex items-center rounded-full bg-white/10 px-2.5 py-1 text-xs font-bold text-yellow-300">
                ★ DESTAQUE
              </span>
            )}
            {i % 4 === 3 && (
              <span className="flex items-center rounded-full bg-white/10 px-2.5 py-1 text-xs font-bold text-green-300">
                ✔ GARANTA JÁ
              </span>
            )}
          </span>
        ))}
        {repeated.map((_, i) => (
          <span key={`logo-${i}`} className="flex items-center px-5">
            <img src="/logo.png" alt="" className="h-10 w-auto opacity-30" style={{ filter: "brightness(0) invert(1)" }} />
          </span>
        ))}
      </div>
    </div>
  );
}
